import {
	SEM_COLOR_FORMS_SURFACE_CONTROL_INDICATOR_DISABLED_LIGHT,
	SEM_COLOR_FORMS_SURFACE_CONTROL_INDICATOR_INTERACTIVE_LIGHT,
} from '@oneaudi/unified-web-common';

import styled, { keyframes } from 'styled-components';

export const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
 
  100% {
    opacity: 1;
  }
`;

export const Tile = styled.button<{ isSelected: boolean; isLoading: boolean }>`
	position: relative;
	width: 68px;
	height: 68px;
	padding: 4px;
	outline: solid ${({ isSelected }) => (isSelected ? '2px' : '0px')};
	outline-color: ${SEM_COLOR_FORMS_SURFACE_CONTROL_INDICATOR_INTERACTIVE_LIGHT};
	border-radius: 100%;
	animation: ${fadeIn} 0.8s ease;
	flex-shrink: 0;

	img,
	svg {
		border-radius: 100%;
		width: 60px;
		object-fit: contain;
		height: 60px;
		opacity: ${({ isLoading }) => (isLoading ? 0.5 : 1)};
	}

	&:not(:disabled):hover {
		outline: solid ${({ isSelected }) => (isSelected ? '2px' : '1px')};
		outline-color: ${SEM_COLOR_FORMS_SURFACE_CONTROL_INDICATOR_INTERACTIVE_LIGHT};
	}

	:disabled {
		outline-color: ${SEM_COLOR_FORMS_SURFACE_CONTROL_INDICATOR_DISABLED_LIGHT};
		img {
			opacity: 0.5;
		}
	}

	.progress-indicator {
		position: absolute;
		inset: 0;
		width: 68px;
		height: 68px;
	}
`;
